import { createFeatureSelector, createSelector } from "@ngrx/store";
import { releaseState } from "../states/release.state";

export const selectReleaseState =
  createFeatureSelector<releaseState>("release");

export const selectRelease = createSelector(
  selectReleaseState,
  (state) => state?.releaseList
);

export const selectReleaseLoading = createSelector(
  selectReleaseState,
  (state) => state?.loading
);

export const selectReleaseError = createSelector(
  selectReleaseState,
  (state) => state?.error
);
